import React from 'react';
import { View } from 'react-native';
import 'react-native-url-polyfill/auto';
import defaultOptions from '../../../constants/sanitizeHtmlOptions';
import { MsgType } from '../../Message/rn';
import { RichTextInWebView } from './RichTextInWebView';
import { SimpleRichText } from './SimpleRichText';
import { transformMarkdownToHtml } from './transformMarkdownToHtml';
export var MaskType;
(function (MaskType) {
  MaskType[MaskType["ArticleOldUI"] = 0] = "ArticleOldUI";
  MaskType[MaskType["ArticleNewUI"] = 1] = "ArticleNewUI";
  MaskType[MaskType["KeyAnswerUI"] = 2] = "KeyAnswerUI";
  MaskType[MaskType["keyAnswerShortUI"] = 3] = "keyAnswerShortUI";
})(MaskType || (MaskType = {}));
export var RichText = function RichText(props) {
  var className = props.className,
    classNameStyles = props.classNameStyles,
    baseStyles = props.baseStyles,
    content = props.content,
    _props$options = props.options,
    options = _props$options === void 0 ? defaultOptions : _props$options,
    _props$shouldHandleDa = props.shouldHandleDateVariable,
    shouldHandleDateVariable = _props$shouldHandleDa === void 0 ? false : _props$shouldHandleDa,
    articleContentTrackingData = props.articleContentTrackingData,
    _props$disableSpecial = props.disableSpecialLink,
    disableSpecialLink = _props$disableSpecial === void 0 ? false : _props$disableSpecial,
    jumpNodeMap = props.jumpNodeMap,
    _props$jumpOrderShort = props.jumpOrderShortCutMap,
    jumpOrderShortCutMap = _props$jumpOrderShort === void 0 ? {} : _props$jumpOrderShort,
    _props$msgType = props.msgType,
    msgType = _props$msgType === void 0 ? MsgType.default : _props$msgType,
    _props$linkTrackingDa = props.linkTrackingData,
    linkTrackingData = _props$linkTrackingDa === void 0 ? {} : _props$linkTrackingDa,
    previewMockData = props.previewMockData,
    _props$shouldSetConta = props.shouldSetContainerWidth,
    shouldSetContainerWidth = _props$shouldSetConta === void 0 ? false : _props$shouldSetConta,
    defaultWidth = props.defaultWidth,
    showMask = props.showMask,
    showLoading = props.showLoading,
    richTextSize = props.richTextSize,
    onWebViewSizeChange = props.onWebViewSizeChange,
    needScrollToUnread = props.needScrollToUnread,
    gradientOffsetTop = props.gradientOffsetTop,
    handleUnreadObjChange = props.handleUnreadObjChange,
    exceededMaxHeight = props.exceededMaxHeight,
    handleScroll = props.handleScroll,
    webViewKey = props.webViewKey,
    debounceSizeChange = props.debounceSizeChange,
    _props$maskType = props.maskType,
    maskType = _props$maskType === void 0 ? MaskType.ArticleOldUI : _props$maskType,
    isUIOptimisationButton = props.isUIOptimisationButton,
    accordionOptions = props.accordionOptions,
    isUIOptimisationTableModal = props.isUIOptimisationTableModal,
    isUIOptimisationTableReview = props.isUIOptimisationTableReview,
    isUIOptimisationImgGifRichText = props.isUIOptimisationImgGifRichText,
    haveMinRichTextWidth = props.haveMinRichTextWidth,
    isUIOptimisationTableRichText = props.isUIOptimisationTableRichText,
    _props$handleDisabled = props.handleDisabledScroll,
    handleDisabledScroll = _props$handleDisabled === void 0 ? function () {} : _props$handleDisabled,
    _props$richTextTouchE = props.richTextTouchEnd,
    richTextTouchEnd = _props$richTextTouchE === void 0 ? function () {} : _props$richTextTouchE,
    summaryMaxHeight = props.summaryMaxHeight,
    isMarkdownText = props.isMarkdownText;
  var useSimpleRichText = false;
  return /*#__PURE__*/React.createElement(View, null, useSimpleRichText ? /*#__PURE__*/React.createElement(SimpleRichText, {
    className: className,
    classNameStyles: classNameStyles,
    baseStyles: baseStyles,
    content: content,
    options: options,
    shouldHandleDateVariable: shouldHandleDateVariable,
    jumpNodeMap: jumpNodeMap,
    jumpOrderShortCutMap: jumpOrderShortCutMap,
    previewMockData: previewMockData,
    disableSpecialLink: disableSpecialLink,
    linkTrackingData: linkTrackingData,
    msgType: msgType,
    onImageError: props.onImageError,
    onImageLoad: props.onImageLoad
  }) : /*#__PURE__*/React.createElement(RichTextInWebView, {
    content: isMarkdownText ? transformMarkdownToHtml(content) : content,
    className: className,
    options: options,
    shouldHandleDateVariable: shouldHandleDateVariable,
    jumpNodeMap: jumpNodeMap,
    jumpOrderShortCutMap: jumpOrderShortCutMap,
    previewMockData: previewMockData,
    disableSpecialLink: disableSpecialLink,
    linkTrackingData: linkTrackingData,
    msgType: msgType,
    onImageError: props.onImageError,
    onImageLoad: props.onImageLoad,
    shouldSetContainerWidth: shouldSetContainerWidth,
    defaultWidth: defaultWidth,
    showMask: showMask,
    showLoading: showLoading,
    richTextSize: richTextSize,
    onWebViewSizeChange: onWebViewSizeChange,
    needScrollToUnread: needScrollToUnread,
    gradientOffsetTop: gradientOffsetTop,
    handleUnreadObjChange: handleUnreadObjChange,
    exceededMaxHeight: exceededMaxHeight,
    handleScroll: handleScroll,
    webViewKey: webViewKey,
    debounceSizeChange: debounceSizeChange,
    articleContentTrackingData: articleContentTrackingData,
    maskType: maskType,
    isUIOptimisationButton: isUIOptimisationButton,
    accordionOptions: accordionOptions,
    isUIOptimisationTableModal: isUIOptimisationTableModal,
    isUIOptimisationTableReview: isUIOptimisationTableReview,
    isUIOptimisationImgGifRichText: isUIOptimisationImgGifRichText,
    haveMinRichTextWidth: haveMinRichTextWidth,
    isUIOptimisationTableRichText: isUIOptimisationTableRichText,
    handleDisabledScroll: handleDisabledScroll,
    richTextTouchEnd: richTextTouchEnd,
    summaryMaxHeight: summaryMaxHeight
  }));
};